import { useThrottleFn } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/use-throttle-fn
 */
export default useThrottleFn;
